/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';


import { getTodayScheduleAsync } from '../../actions/DataActionExtension.g';

import { IEvent } from '../../components/sutra-event';

import errors from '../../resources/modules/errors.json';
import Accordion, { AccordionData } from '../../components/accordion';

import { IEcommLiveStreamMobileData } from './ecomm-live-stream-mobile.data';
import { IStreamsData, IEcommLiveStreamMobileProps } from './ecomm-live-stream-mobile.props.autogenerated';

var moment = require('moment-timezone');

export interface IEcommLiveStreamMobileViewProps extends IEcommLiveStreamMobileProps<IEcommLiveStreamMobileData> {
  streams: IStreamsData[];
  current: React.ReactNode;
  activeURL: string;
}

/**
 *
 * EcommLiveStreamMobile component
 * @extends {React.PureComponent<IEcommLiveStreamMobileProps<IEcommLiveStreamMobileData>>}
 */
class EcommLiveStreamMobile extends React.PureComponent<IEcommLiveStreamMobileProps<IEcommLiveStreamMobileData>> {
  public state: any = { rawData: [], time: moment.tz('Asia/Singapore') };

  private _interval = 300000;
  private _timeID: any;
  private _activeURL = '';

  public async componentDidMount() {
    const { config } = this.props;

    const data = await getTodayScheduleAsync({ callerContext: this.props.context.actionContext },
      config.env, config.entity, config.containerName, config.blobName, config.libraryName);

    if (this.state.rawData.length === 0 && data.length > 0) {
      this.setState({ rawData: data });
    }

    this._timeID = setInterval(() => this.setState({ time: moment.tz('Asia/Singapore') }), this._interval);
  }

  public render(): JSX.Element | null {
    const { config } = this.props;

    const EcommLiveStreamMobileViewProps = {
      ...this.props,
      streams: config.streams,
      current: this._getSchedule(),
      activeURL: this._activeURL
    };

    return this.props.renderView(EcommLiveStreamMobileViewProps);
  }

  public componentWillUnmount() {
    clearInterval(this._timeID);
  }

  private _getSchedule(): JSX.Element | null {
    const { config } = this.props;

    let result: JSX.Element | null = null;
    let accordianContent: AccordionData[] = [];

    if (this.state.rawData && this.state.rawData.length !== 0) {
      const now = this.state.time.format('hh:mm A');

      const errorIdx = this.state.rawData.findIndex((error: String) => error === errors.sutraNoSchedule || error === errors.sutraNoDictionary);

      if (errorIdx !== -1) {
        return null;
      }

      for (let i = 0; i < this.state.rawData.length; ++i) {
        const index = i;

        let record: IEvent = JSON.parse(this.state.rawData[`${i}`]);
        let active = false;

        if (record.Time) {
          const current = this._isCurrentTimeLarger(now, record.Time);

          if (index === this.state.rawData.length - 1) {
            const end = this._isCurrentTimeLarger(now, config.closingTime);

            active = current && !end ? true : false;
          } else {
            if (this.state.rawData[index + 1]) {
              let nxtime = JSON.parse(this.state.rawData[index + 1]).Time;

              if (nxtime === '') {
                const checkTime = (slot: string) => JSON.parse(slot).Time !== '';
                const subArray = this.state.rawData.slice(index + 1);
                const idx = subArray.findIndex(checkTime);

                nxtime = JSON.parse(subArray[`${idx}`]).Time;
              }

              let next = this._isCurrentTimeLarger(now, nxtime);

              active = current && !next ? true : false;
            }
          }
        }

        this._activeURL = record.SutraUrl ? `${config.issuu}/${record.SutraUrl}/${record.Page}` : '';
        let tempAccordianItem: AccordionData = {
          titleEnglish: this.props.context.request.locale=='en-SG'&&record.EnglishName ? record.EnglishName: "",
          titleChinese: this.props.context.request.locale=='zh-Hans'&&record.ChineseName ? record.ChineseName: "",
          time: record.Time ? record.Time : '',
          active:active,
          language:this.props.context.request.locale,
          //@ts-ignore
          content: this._activeURL?(<iframe src={this._activeURL} style={{height:"100%",width: "100%"}} loading="lazy" scrolling = "no"/>):null
        }
        accordianContent.push(tempAccordianItem);
      }
    }
    let Accordian = (<Accordion items={accordianContent} />);
    result = (accordianContent.length>0)?(<div>{Accordian}</div>):null;
    return result;
  }

  private _isCurrentTimeLarger(currTime: string, eventTime: string): boolean {
    // Returns true if current time is larger or equal to event time.

    const currUnit = currTime.indexOf('AM') !== -1 ? 0 : 1;
    const eventUnit = eventTime.indexOf('AM') !== -1 ? 0 : 1;

    if (currUnit > eventUnit) {
      return true;
    }

    if (currUnit < eventUnit) {
      return false;
    }

    // Compare hour when both current and event are in the same units.

    let currHour = parseInt(currTime.substring(0, currTime.indexOf(':')));
    let eventHour = parseInt(eventTime.substring(0, eventTime.indexOf(':')));

    currHour = currHour === 12 ? 0 : currHour;
    eventHour = eventHour === 12 ? 0 : eventHour;

    if (currHour > eventHour) {
      return true;
    }

    // Compare minutes when both current and event are in the same units and same hour.

    if (currHour === eventHour) {
      const currMin = parseInt(currTime.substring(currTime.indexOf(':') + 1, currTime.indexOf(' ')));
      const eventMin = parseInt(eventTime.substring(eventTime.indexOf(':') + 1, eventTime.indexOf(' ')));

      if (currMin > eventMin) {
        return true;
      }
    }

    return false;
  }
}

export default EcommLiveStreamMobile;
